import { render, staticRenderFns } from "./WizardSetting.vue?vue&type=template&id=bbff498a&"
import script from "./WizardSetting.vue?vue&type=script&lang=js&"
export * from "./WizardSetting.vue?vue&type=script&lang=js&"
import style0 from "./WizardSetting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VAvatar,
  VBtn,
  VCheckbox,
  VContainer,
  VFlex,
  VIcon,
  VLayout,
  VRadio,
  VRadioGroup,
  VSelect,
  VSnackbar,
  VTextField,
})
